import { useSelector } from 'react-redux';
import { getAdvertisers, getClientMapping, getPartners, getSalesReps } from './selector';
import { REDUCER_KEY } from './reducer';

export function useCampaignDuplicateModal() {
    const state = useSelector(state => state[REDUCER_KEY]);

    const advertisers = useSelector(getAdvertisers);
    const salesReps = useSelector(getSalesReps);
    const partners = useSelector(getPartners);
    const clientMapping = useSelector(getClientMapping);
    const clientGrouping = _.groupBy(_.get(state, 'campaign.clients', []), 'type');

    return {
        ...state,
        open: state.isModalOpen ?? false,
        advertisers,
        salesReps,
        partners,
        clientMapping,
        clientGrouping,
    };
}
